import { fetchWithAuth } from './auth'

export interface ParsedLineItem {
  name: string
  amount: number
  category?: string
}

export interface UploadResult {
  key: string
  url: string
  filename: string
  contentType: string
  size: number
  parsed?: {
    merchant?: string
    purchasedAt?: string
    total?: number
    lineItems?: ParsedLineItem[]
  }
}

const uploadUrl = `${import.meta.env.VITE_API_URL || 'http://localhost:8080'}/upload`

export async function uploadFile(file: File): Promise<UploadResult> {
  const formData = new FormData()
  formData.append('file', file)

  const response = await fetchWithAuth(uploadUrl, { method: 'POST', body: formData })

  if (!response.ok) {
    const text = await response.text()
    throw new Error(`Upload failed: ${response.status} ${response.statusText} - ${text}`)
  }
  return response.json() as Promise<UploadResult>
}
